import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FilterFieldComponent } from '../filter-field.component';
import { MultiSelectFilterField } from './filter-field-multi-select';

@Component({
  selector: 'va-filter-multi-items-and-status',
  template: `
    <va-multi-select
      (selection)="applyFilter($event)"
      [options]="filterField.options"
      [selected]="filterField.value"
      [displayProperty]="filterField.optionDisplayProperty"
      [placeholderText]="filterField.placeholderText"
      [limitResults]="filterField.limitResults"
    />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MultiSelectFilterFieldComponent extends FilterFieldComponent<MultiSelectFilterField> {}
